var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vca-card',[(_vm.current)?_c('div',[_c('UsersDisplay')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }